import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * CompanyChangeBlur - componente que mostra overlay de blur quando empresa está mudando
 * Escuta eventos de mudança de empresa e mostra overlay com loading
 */
const CompanyChangeBlur = () => {
  const [isChangingCompany, setIsChangingCompany] = useState(false);

  useEffect(() => {
    const handleCompanyChange = (event) => {
      const { company } = event.detail || {};
      if (company) {
        setIsChangingCompany(true);
      }
    };

    const handleCompanyChangeComplete = () => {
      setIsChangingCompany(false);
    };

    // Escutar mudanças de empresa
    window.addEventListener('company-changed', handleCompanyChange);
    window.addEventListener('company-change-complete', handleCompanyChangeComplete);

    return () => {
      window.removeEventListener('company-changed', handleCompanyChange);
      window.removeEventListener('company-change-complete', handleCompanyChangeComplete);
    };
  }, []);

  // Auto-hide após um tempo para evitar que fique travado
  useEffect(() => {
    if (isChangingCompany) {
      const timer = setTimeout(() => {
        setIsChangingCompany(false);
      }, 3000); // 3 segundos máximo

      return () => clearTimeout(timer);
    }
  }, [isChangingCompany]);

  if (!isChangingCompany) {
    return null;
  }

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] pointer-events-none">
      <div
        className="pointer-events-auto inline-flex items-center gap-3 rounded-full border border-[color:var(--border)] bg-[color:var(--surface)] px-4 py-2 text-sm text-[color:var(--text-primary)] backdrop-blur"
        style={{ boxShadow: 'var(--shadow)' }}
      >
        <span className="relative flex h-8 w-8 items-center justify-center rounded-full bg-[color:var(--surface-muted)]">
          <RefreshCw className="h-4 w-4 animate-spin text-[color:var(--accent)]" />
        </span>
        <div className="flex flex-col leading-tight">
          <span className="text-[10px] uppercase tracking-[0.2em] text-[color:var(--text-muted)]">
            Sincronizando
          </span>
          <span className="font-semibold tracking-tight">
            Carregando dados da empresa...
          </span>
        </div>
      </div>
    </div>
  );
};

export default CompanyChangeBlur;
